import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import { ref } from "vue";
export default function (id: string) {
    const logItems = ref([]);
    const getLog = async () => {
        await defineHeaderAxios();
        Axios.get(`/api/sensor/history/${id}`)
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    logItems.value = result.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    getLog();
    return {
        logItems,
    };
}
